import EquipmentGraphics from './EquipmentGraphics'
import EquipmentClass from './EquipmentClass'
import BaseLineItemEntity from '../baseclasses/BaseLineItemEntity'
import * as _ from "lodash";
export class EquipmentLineItem extends BaseLineItemEntity {
    ID?: number;
    EquipmentGraphicsID?: number;
    EquipmentGraphics?: EquipmentGraphics;
    EquipmentAssetNumber: string;
    SerialNumber: string;
    MaterialNumber: string;
    Model: string;
    Location: string;
    CurrentLocation: string;
    MoveToLocation: string;
    NewCustomerNumber: string;
    EquipmentClassID: number;
    EquipmentClass?: EquipmentClass
    CanEditEquipmentNumbers: boolean;

    constructor() {
        super();
        this.EquipmentGraphics = new EquipmentGraphics();
    }

}

export default EquipmentLineItem;